import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5006';

const api = axios.create({ baseURL: API_URL });

// Token vai no AuthContext via axios.defaults.headers.common.Authorization,
// mas também propagamos pra essa instância pra evitar drift.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('pc_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
